// Profile description modal with the text editor and info box.
// Render standalone via /styleguide/c/ProfileSettingsProfileDescriptionForm/<Example>/raw.
import ProfileSettingsProfileDescriptionForm from './ProfileSettingsProfileDescriptionForm';

const noop = () => null;

const baseProps = {
  isOpen: true,
  onClose: noop,
  onManageDisableScrolling: noop,
  onSubmit: noop,
  updateInProgress: false,
  isCustomer: false,
};

export const ProfileDescription = {
  component: ProfileSettingsProfileDescriptionForm,
  props: {
    ...baseProps,
    initialValue: '<p>Olen kokenut ohjelmistokehittäjä, joka rakentaa verkkopalveluita.</p>',
  },
  group: 'forms',
};

// A long word without whitespace must wrap inside the editor, not widen the modal.
export const LongUnbrokenText = {
  component: ProfileSettingsProfileDescriptionForm,
  props: {
    ...baseProps,
    initialValue: `<p>${'lorem'.repeat(80)}</p>`,
  },
  group: 'forms',
};
